import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { inventoryService } from "../../../Services/AccountingServices/inventory.service";
import BootstrapTable from "react-bootstrap-table-next";
import * as dateHelper from "../../../Helpers/DateHelper";

const InventoryDocuments = ({ show, handleHide, inventoryDocumentGuid }) => {
  const { t: translator } = useTranslation();
  const [data, setData] = useState({});

  useEffect(() => {
    inventoryService
      .inventoryDocuments(inventoryDocumentGuid)
      .then((res) => setData(res.data.data))
      .catch((err) => console.log(err));
  }, []);

  function dateFormatter(cell, row) {
    return dateHelper.formatUtcToDate(row.documentDate);
  }
  function documentTypeNameFormatter(cell, row) {
    return translator(row.documentTypeName);
  }

  const columns = [
    {
      dataField: "documentDate",
      formatter: dateFormatter,
      text: translator("InitialState-Date"),
    },
    {
      dataField: "documentNumber",
      text: translator("InitialState-DocumentNumber"),
    },
    {
      dataField: "documentTypeName",
      formatter: documentTypeNameFormatter,
      text: translator("InitialState-DocumentTypeName"),
    },
  ];

  return (
    <Modal size="lg" show={show} onHide={handleHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{translator("Inventory-Documents")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <BootstrapTable
          remote
          keyField="documentGuid"
          data={data}
          columns={columns}
          rowClasses="boostrap-table-row"
          noDataIndication={translator("No-Data")}
        />
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-secondary"
          data-dismiss="modal"
          onClick={handleHide}
        >
          {translator("Close")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default InventoryDocuments;
